import { useCallback } from 'react';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { getTourSteps } from './tourSteps';
import { useT } from '../i18n';
import { NAV_EXPAND_ALL_EVENT, NAV_RESTORE_EVENT } from '../components/layout/nav-model';

export function useProductTour() {
  const t = useT();

  const runTour = useCallback(() => {
    // Un módulo deshabilitado para el tenant/rol actual no renderiza su ítem
    // de Sidebar (renderLink devuelve null, no solo lo oculta con CSS) — filtrar
    // por presencia real en el DOM evita mostrar el paso del tour de un módulo
    // al que el usuario no tiene acceso.
    const allSteps = getTourSteps(t);
    const steps = allSteps.filter(
      step => typeof step.element === 'string' && document.querySelector(step.element) !== null
    );
    if (steps.length === 0) {
      window.dispatchEvent(new Event(NAV_RESTORE_EVENT));
      return;
    }

    const tourDriver = driver({
      showProgress: true,
      steps,
      nextBtnText: t.tour.next,
      prevBtnText: t.tour.prev,
      doneBtnText: t.tour.done,
      progressText: t.tour.progress,
      onDestroyed: () => window.dispatchEvent(new Event(NAV_RESTORE_EVENT)),
    });
    tourDriver.drive();
  }, [t]);

  const start = useCallback(() => {
    // Los grupos del menú pueden estar plegados: ábrelos todos para que el tour vea cada ítem.
    window.dispatchEvent(new Event(NAV_EXPAND_ALL_EVENT));
    requestAnimationFrame(() => runTour());
  }, [runTour]);

  return { start };
}
